import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CardField from '../cardField/CardField.jsx';
import CardValidDate from '../cardValidDate/CardValidDate';
import NumberField from '../NumberField/NumberField';
import CardCnpjCpf from '../cardCnpjCpf/CardCnpjCpf';
import TextField from '../../passengerInfo/textField/TextField';
import FeatureService from '../../../services/feature/FeatureService';
import Features from '../../../const/Features';
import Identity from '../../modules/identity';
import {eye} from 'react-icons-kit/feather/eye'
import {eyeOff} from 'react-icons-kit/feather/eyeOff'
import StyleFieldsEncode from '../../../utils/StyleFieldsEncode.js';
import { isFromCallcenter } from '../../../services/queryService/QueryService.js';
import EyeEncode from '../eyeEncode/EyeEncode.jsx';
import InstallmentsSelect from '../installments/InstallmentsSelect.jsx';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeCreditCard: PropTypes.func.isRequired,
  changeValidDate: PropTypes.func.isRequired,
  changeSecurityCode: PropTypes.func.isRequired,
  changeName: PropTypes.func.isRequired,
  changeCnpjCpf: PropTypes.func.isRequired,
  changeInstallments: PropTypes.func.isRequired,
  securityCodeMaxLength: PropTypes.number.isRequired,
  sessionId: PropTypes.string,
  quotationJourney: PropTypes.object.isRequired
};

const defaultProps = {
  sessionId: null
};

class CheckoutForm extends React.Component {
  createRef = value => {
    if (value) {
      if (!this.fields) {
        this.fields = [];
      }
      this.fields[this.fields.length] = value;
    }
  };

   validate = () => {
    let isValidForm = true;
    this.fields.forEach(field => {
      if (field && typeof field.validate === 'function') {
        isValidForm = field.validate() && isValidForm;
      }
    });
    return isValidForm;
  };

  constructor(props) {    
    super(props);    
    this.state = {
      quotationJourney: this.props.quotationJourney,
      cardMonthYearSelectFieldToggle: false,
      callCenterMode: this.callCenterMode()      
    };
    this.style = StyleFieldsEncode
  }

  componentDidMount() {
    this.featureIdentityFingerprint();
    this.featureCardMonthYearSelectField();
  }

  callCenterMode() {
    return this.props.isCallcenterEnabled && isFromCallcenter();
  }

  featureIdentityFingerprint() {
    let idCardField = 'checkoutForm-' + this.props.id + '-cardInfo_textFieldId';
    Identity.capturar(this.props.sessionId, 'PAGAMENTO_CARTAO');
    Identity.observarColagem(this.props.sessionId, 'PAGAMENTO_CARTAO', idCardField);
  }

  featureCardMonthYearSelectField() {
    FeatureService.isFeatureEnabled(Features.CARD_MONTH_YEAR_SELECT_FIELD)
      .then(isEnabled => {
        if (isEnabled) {
          this.setState({
            cardMonthYearSelectFieldToggle: true
          });
        }
      })
      .catch(() => {});
  }

  handleIcoEye = (styleField,iconField) => {    
    if(this.state[styleField]=== this.style.encode){
      this.setState({       
          [styleField]: this.style.decode ,
          [iconField]:eye              
      })
    } else {
      this.setState({        
        [styleField]:this.style.encode ,
        [iconField]:eyeOff           
      })
    }
    if(this.state.lastField && this.state.lastField !== styleField){
      this.setState({        
        [this.state.lastField]:this.style.encode ,
        [this.state.lastIconField]:eyeOff           
      })
    } 
      this.setState({        
        lastField: styleField ,
        lastIconField:iconField           
      }) 
  };

  onBlurFieldToIco = (styleField,iconField,e) =>{    
    if(e.target.value!=""){
     this.setState({       
      [styleField]:this.style.encode ,
      [iconField]:eyeOff             
     })
    }
  };

  renderEyeEncode(iconEye,className,iconIdentifier,styleFieldIdentifier){
    if(this.state.callCenterMode)
     return(    
      <EyeEncode
        iconEye={ iconEye}
        size={20}
        className={className}
        iconIdentifier={iconIdentifier}
        styleFieldIdentifier={styleFieldIdentifier}
        onClick={(e) => this.handleIcoEye(styleFieldIdentifier,iconIdentifier)} 
      />      
    )
  }

  render() {
    return (
      <div id={`checkoutForm-${this.props.id}`}>
        <Row>          
          <Col xs={11}>           
            <CardField              
              id={`checkoutForm-${this.props.id}-cardInfo`}
              required={true}
              changeValue={this.props.changeCreditCard}
              label="components.checkoutInfo.card.label"
              placeholder="components.checkoutInfo.card.placeholder"
              errorMessage="components.checkoutInfo.card.errorMessage"
              ref={this.createRef}              
              styleEncode={this.state.styleFieldCard || this.style.decode}
              onBlurFieldToIco={this.onBlurFieldToIco}
              styleFieldIdentifier={'styleFieldCard'}
              iconIdentifier={'iconCard'}             
              callCenterMode={this.state.callCenterMode}        
            />
          </Col>
          <Col xs={1}>
          {this.renderEyeEncode(this.state.iconCard || eye,'contentEye','iconCard','styleFieldCard') }
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <CardValidDate
              id="cardValidDate"
              changeValue={this.props.changeValidDate}
              ref={this.createRef}
              cardMonthYearSelectFieldToggle={this.state.cardMonthYearSelectFieldToggle}
              handleIcoEye={this.handleIcoEye}
              onBlurFieldToIco={this.onBlurFieldToIco}
              iconEyeMonth={this.state.iconMonth || eye}
              styleEncodeMonth={this.state.styleFieldMonth || this.style.decode}
              iconEyeYear={this.state.iconYear || eye}
              styleEncodeYear={this.state.styleFieldYear || this.style.decode}
              renderEye={true}    
              styleFieldIdentifierMonth={'styleFieldMonth'}
              iconIdentifierMonth={'iconMonth'}     
              styleFieldIdentifierYear={'styleFieldYear'}
              iconIdentifierYear={'iconYear'}  
              classNameIco={'contentEyeValidDate'}
              callCenterMode={this.state.callCenterMode}            
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>           
            <NumberField
              id="cardSecurityCode"
              label="components.checkoutInfo.cardSecurityCode.label"
              placeholder="components.checkoutInfo.cardSecurityCode.placeholder"
              errorMessage="components.checkoutInfo.cardSecurityCode.errorMessage"
              invalidValueErrorMessage="components.checkoutInfo.cardSecurityCode.invalidValueErrorMessage"
              required={true}
              maxLength={this.props.securityCodeMaxLength}
              minLength={3}
              changeValue={this.props.changeSecurityCode}
              ref={this.createRef}              
              styleEncode={this.state.styleFieldCvv || this.style.decode}
              onBlurFieldToIco={this.onBlurFieldToIco}
              styleFieldIdentifier={'styleFieldCvv'}
              iconIdentifier={'iconCvv'}              
              callCenterMode={this.state.callCenterMode}   
            />
          </Col>
          <Col xs={1}> 
          {this.renderEyeEncode(this.state.iconCvv || eye,'contentEye','iconCvv','styleFieldCvv') } 
          </Col>
        </Row>
        {this.props.showInstallments && (
        <Row>
          <Col xs={11}>
            <InstallmentsSelect 
              id={`installments`}
              ref={this.createRef} 
              required={true}
              changeValue={this.props.changeInstallments}
              quotationJourney={this.props.quotationJourney} 
              onBlurFieldToIco={this.onBlurFieldToIco}
              styleFieldIdentifier={'styleFieldInstallments'}
            /> 
          </Col> 
        </Row>)}
        <Row>
          <Col xs={11} className="PassengerInfo__name">            
            <TextField
              id={`checkoutForm-name`}
              ref={this.createRef}
              label="components.checkoutInfo.cardName.label"
              placeholder="components.checkoutInfo.cardName.placeholder"
              maxLength={50}
              required={true}
              isUpperCase={true}
              errorMessage="components.checkoutInfo.cardName.errorMessage"
              changeValue={this.props.changeName}             
              styleEncode={this.state.styleFieldPassengerName || this.style.decode}
              onBlurFieldToIco={this.onBlurFieldToIco}
              styleFieldIdentifier={'styleFieldPassengerName'}
              iconIdentifier={'iconPassengerName'}              
              callCenterMode={this.state.callCenterMode}   
            />
          </Col>
          <Col xs={1} >
          {this.renderEyeEncode(this.state.iconPassengerName || eye,'contentEye','iconPassengerName','styleFieldPassengerName') } 
          </Col>
        </Row>
        <Row>
          <Col xs={11}>           
            <CardCnpjCpf
              id="cnpjCpf"
              errorMessage="components.checkoutInfo.cardCnpjCpf.errorMessage"
              invalidValueErrorMessage="components.checkoutInfo.cardCnpjCpf.invalidValueErrorMessage"
              required={true}
              changeValue={this.props.changeCnpjCpf}
              ref={this.createRef}              
              styleEncode={this.state.styleFieldCnpjCpf || this.style.decode}
              onBlurFieldToIco={this.onBlurFieldToIco}
              styleFieldIdentifier={'styleFieldCnpjCpf'}
              iconIdentifier={'iconCnpjCpf'}              
              callCenterMode={this.state.callCenterMode}  
            />
          </Col>
          <Col xs={1}>
           {this.renderEyeEncode(this.state.iconCnpjCpf || eye,'contentEye','iconCnpjCpf','styleFieldCnpjCpf') } 
          </Col>
        </Row>
      </div>
    );
  }
}

CheckoutForm.propTypes = propTypes;
CheckoutForm.defaultProps = defaultProps;

export default CheckoutForm;



// WEBPACK FOOTER //
// ./src/components/checkoutInfo/checkoutForm/CheckoutForm.jsx